import React from 'react';
import { TRACKING } from 'common/constants/constants';
import investmentProfileCTA from 'images/investmentProfileCTA.jpg';
import CtaPage from 'components/CtaPage';
import { TEXT_POSITION } from 'components/CtaPage/constants';

const SECTION_TYPES = {
  INVESTMENT_PROFILE: 'INVESTMENT_PROFILE',
  FEATURE: 'FEATURE'
};

const TEXTS = {
  [SECTION_TYPES.INVESTMENT_PROFILE]:
    'Strike the right balance between new feature work and keeping the ' +
    'lights on with Investment Profile. See what your engineering ' +
    'teams are working on, get insight into how that compares to the ' +
    'industry, and identify opportunities to optimize R&D effort.',
  [SECTION_TYPES.FEATURE]:
    'Drill into each of your investment areas to get a more granular ' +
    'view of the work being done, however it’s categorized. ' +
    'You can also customize your investment categories and benchmarks ' +
    'to accurately reflect how you work and align to improvement goals.'
};

const InvestmentCarvingCta = () => (
  <CtaPage
    textsMap={TEXTS}
    page={TRACKING.PAGES.INVESTMENT_PROFILE}
    pageTab={TRACKING.PAGE_TABS.INVESTMENT_PROFILE_CTA}
    buttonLineProps={{
      textWidth: '70%',
      leftText:
        'Translate engineering effort into terms your business understands'.toUpperCase(),
      buttonText: 'BOOK A DEMO NOW'
    }}
    backgroundImage={investmentProfileCTA}
    sections={[
      {
        sectionType: SECTION_TYPES.INVESTMENT_PROFILE,
        buttonPosition: {
          left: '43%',
          top: '14rem'
        },
        coverProps: {
          height: '50rem',
          width: '50%',
          position: { top: 0 }
        },
        textPosition: {
          left: TEXT_POSITION,
          top: '14rem'
        },
        isTextLeft: true
      },
      {
        sectionType: SECTION_TYPES.FEATURE,
        buttonPosition: {
          right: '35%',
          top: '25rem'
        },
        coverProps: {
          height: '50rem',
          width: '50%',
          position: { right: 0, top: 0 }
        },
        textPosition: {
          right: TEXT_POSITION,
          top: '14rem'
        }
      }
    ]}
  />
);

export default InvestmentCarvingCta;
